import { render, staticRenderFns } from "./individual_detial.vue?vue&type=template&id=0a916670&scoped=true"
import script from "./individual_detial.vue?vue&type=script&lang=js"
export * from "./individual_detial.vue?vue&type=script&lang=js"
import style0 from "./individual_detial.vue?vue&type=style&index=0&id=0a916670&prod&scoped=true&lang=less"
import style1 from "./individual_detial.vue?vue&type=style&index=1&id=0a916670&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a916670",
  null
  
)

export default component.exports